import CleaningIndexVue from "@/views/housekeeping/cleaning/CleaningIndex.vue";

const cleaning = [
  {
    path: "/cleaning",
    name: "cleaning",
    component: CleaningIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin","receptionist","supervisor","housekeeping"],
      public: false,
    },
  },
];

export default cleaning;
